import main from '@reconciliation/pages/main.vue';
export default [
  {
    path: 'reconciliation',
    component: main,
    redirect: 'reconciliation/list',
    children: [
      {
        path: 'list',
        name: 'reconciliation/list',
        meta: { title: '对账单记录', auth: true },
        component: () => import('@reconciliation/pages/index-list.vue'),
      },
      {
        path: 'error',
        name: 'reconciliation/error',
        meta: { title: '差错记录', auth: true },
        component: () => import('@reconciliation/pages/error-list.vue'),
      },
    ],
  },
  {
    path: 'reconciliation/list/detail/:id',
    name: 'reconciliation/list/detail',
    meta: { title: '对账单详情', auth: true },
    component: () => import('@reconciliation/pages/detail.vue'),
  },
  {
    path: 'reconciliation/error/detail/:id',
    name: 'reconciliation/error/detail',
    meta: { title: '差错详情', auth: true },
    component: () => import('@reconciliation/pages/detail.vue'),
  },
];
